export default __webpack_public_path__ + "static/media/DSC_7963.30709017.jpg";